import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  Stack,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  LoadingSkeleton,
  NoDataSkeleton,
} from '../../../../common/components';
import { formatPercentage } from '../utils/formatters';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PaidIcon from '@mui/icons-material/Paid';

const DifferimentsDataTable = ({ data, isLoading, isFetching, showError, onView, onPay }) => {
  if (isLoading || isFetching) {
    return <LoadingSkeleton />;
  }

  return (
    <GeneralTableBox>
      <Table size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Diferimiento total</HeadTableCell>
            <HeadTableCell>Pagado</HeadTableCell>
            <HeadTableCell>Pendiente</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {showError || !data || data.length === 0 ? (
            <NoDataSkeleton colSpan={5} message="No se encontraron contratos con diferimiento" />
          ) : (
            data.map((item) => (
              <TableRow key={item.uuid_contract}>
                <RowTableCell>
                  <Typography fontWeight="bold">{item.contract_number}</Typography>
                </RowTableCell>
                <RowTableCell>{formatPercentage(item.total_differiment)} cuotas</RowTableCell>
                <RowTableCell>{formatPercentage(item.paid_differiment)} cuotas</RowTableCell>
                <RowTableCell>{formatPercentage(item.pending_differiment)} cuotas</RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <Tooltip title="Ver detalle">
                      <IconButton size="small" onClick={() => onView?.(item.uuid_contract)}>
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Pagos e intenciones">
                      <IconButton size="small" onClick={() => onPay?.(item.uuid_contract)}>
                        <PaidIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default DifferimentsDataTable;
